function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#db)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.851 437.883C54.851 437.883 47.651 425.138 65.933 422.368C76.799 420.689 87.9176 422.031 98.072 426.247C98.072 426.247 85.327 410.732 105.272 404.082C125.217 397.432 145.723 412.948 145.723 412.948C145.723 412.948 125.781 375.822 141.293 373.051C156.805 370.28 165.12 386.351 165.12 386.351C165.12 386.351 163.458 340.359 195.597 339.251C227.736 338.143 224.411 397.988 224.411 397.988C224.411 397.988 238.264 371.388 261.537 370.282C284.81 369.176 273.174 414.833 273.174 414.833C273.174 414.833 277.607 404.083 293.122 402.975C308.637 401.867 307.529 414.875 307.529 414.875C307.529 414.875 327.477 386.909 349.642 388.575C371.807 390.241 362.387 417.944 362.387 417.944C385.106 416.282 390.093 441.217 390.093 441.217H38.781L54.851 437.883Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.941 71.055C240.941 71.055 231.249 80.109 217.396 91.746",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.109 181.159C225.109 181.159 172.528 333.021 225.109 421.952L219.509 437.744L264.681 418.627L259.029 292.287C259.029 292.287 294.687 213.208 291.168 197.893C287.649 182.578 286.835 160.213 286.835 160.213",
  fill: "#9068DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.893 162.446C239.893 162.446 228.705 345.023 260.301 431.466L253.701 441.166H309.894C309.894 441.166 316.034 208.939 316.034 158.819L239.893 162.446Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.276 21.184V44.911L284.667 52.137V12.097L255.276 4.87103V21.184Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.877 29.397C272.312 29.397 272.664 29.0446 272.664 28.61C272.664 28.1753 272.312 27.823 271.877 27.823C271.442 27.823 271.09 28.1753 271.09 28.61C271.09 29.0446 271.442 29.397 271.877 29.397Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.809 29.397C260.244 29.397 260.596 29.0446 260.596 28.61C260.596 28.1753 260.244 27.823 259.809 27.823C259.374 27.823 259.022 28.1753 259.022 28.61C259.022 29.0446 259.374 29.397 259.809 29.397Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.352 33.297V21.184H257.282",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.357 21.184H267.289",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.733 27.39V31.596C283.272 31.596 283.806 31.4898 284.304 31.2835C284.802 31.0771 285.255 30.7747 285.636 30.3934C286.018 30.0121 286.32 29.5595 286.526 29.0613C286.733 28.5632 286.839 28.0292 286.839 27.49V27.119C286.593 24.564 282.733 24.83 282.733 27.39Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.733 31.596C283.272 31.596 283.806 31.4898 284.304 31.2834C284.802 31.0771 285.255 30.7746 285.636 30.3934C286.018 30.0121 286.32 29.5594 286.526 29.0613C286.733 28.5631 286.839 28.0292 286.839 27.49",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.004 38.501C266.55 38.5016 267.091 38.3944 267.596 38.1858C268.1 37.9772 268.559 37.6712 268.945 37.2852C269.332 36.8992 269.638 36.4409 269.847 35.9364C270.056 35.4319 270.164 34.8911 270.164 34.345",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.276 44.912L284.667 52.138",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.349 33.309L266.003 33.963",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.733 26.808C282.733 26.808 278.987 19.976 278.804 16.928L277.784 21.184C277.784 21.184 270.857 19.045 266.607 13.784V19.2C266.607 19.2 258.434 17.477 256.334 12.03V17.111C254.811 16.0215 253.685 14.4652 253.126 12.678",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.275 21.739C255.275 21.739 240.314 5.89602 260.595 1.51602C275.107 -1.62898 282.757 6.12902 282.757 6.12902C282.757 6.12902 287.757 8.52302 289.794 12.585C291.831 16.647 292.664 27.085 284.668 34.844",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.035 94.628V158.812L225.109 181.16V109.678C225.11 97.3623 229.239 85.4024 236.838 75.7101C244.436 66.0178 255.065 59.1526 267.024 56.212V56.212C272.85 54.7803 278.925 54.6922 284.79 55.9544C290.655 57.2167 296.156 59.7961 300.877 63.4977C305.599 67.1993 309.416 71.9261 312.041 77.3206C314.666 82.715 316.03 88.6358 316.03 94.635L316.035 94.628Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.276 143.091C255.276 143.091 255.226 90.228 225.11 89.891C194.994 89.554 205.471 55.052 205.471 55.052L156.11 66.232C156.11 66.232 147.998 113.565 189.579 127.739C210.83 134.992 201.736 184.448 201.736 184.448L256.336 178.12V170.839",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.11 66.223C156.11 66.223 147.998 113.556 189.579 127.73C210.83 134.984 201.741 184.443 201.741 184.443",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.244 71.055C308.244 71.055 336.809 108.447 336.438 152.406C336.067 196.365 268.098 192.306 242.238 157.206C242.238 157.206 225.243 145.387 227.831 142.799C230.419 140.211 241.738 142.692 241.738 142.692C241.738 142.692 239.655 136.708 242.791 138.192C245.352 139.525 247.808 141.05 250.138 142.755L291.409 145.498L281.989 106.976",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.894 162.446C239.894 162.446 228.706 345.023 260.302 431.466",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.244 71.055C308.244 71.055 336.809 108.447 336.438 152.406C336.067 196.365 268.098 192.306 242.238 157.206C242.238 157.206 225.243 145.387 227.831 142.799C230.419 140.211 241.738 142.692 241.738 142.692C241.738 142.692 239.655 136.708 242.791 138.192C245.352 139.525 247.808 141.05 250.138 142.755L291.409 145.498L281.989 106.976",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.287 181.88V213.01C271.231 202.665 249.131 164.99 249.131 164.99C267.123 181.946 295.755 188.59 315.287 181.88Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.192 174.848C210.192 174.848 178.33 183.714 171.958 169.03C165.586 154.346 176.945 113.895 176.945 113.895C176.945 113.895 173.62 106.695 175.283 104.752C175.478 104.496 175.73 104.289 176.018 104.146C176.306 104.003 176.624 103.929 176.946 103.929C177.267 103.929 177.585 104.003 177.873 104.146C178.161 104.289 178.413 104.496 178.608 104.752C178.608 104.752 181.24 92.007 185.257 92.977C189.274 93.947 192.084 116.377 193.602 132.009",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.326 38.837V38.537C23.3267 36.1614 23.9331 33.8252 25.088 31.7491C26.2429 29.6731 27.908 27.9259 29.9261 26.6725C31.9443 25.4192 34.2486 24.7011 36.6215 24.5863C38.9943 24.4714 41.3573 24.9635 43.487 26.016C46.8961 21.0468 51.7541 17.2492 57.3994 15.1408C63.0447 13.0323 69.2027 12.7154 75.0346 14.2333C80.8665 15.7512 86.0888 19.03 89.9898 23.6232C93.8909 28.2163 96.2811 33.9003 96.835 39.901C102.129 41.6703 106.732 45.0595 109.993 49.5889C113.255 54.1182 115.009 59.5586 115.009 65.14V65.14C115.009 68.6332 114.321 72.0921 112.984 75.3194C111.647 78.5467 109.688 81.479 107.218 83.9491C104.748 86.4191 101.816 88.3784 98.5884 89.7152C95.3611 91.052 91.9022 91.74 88.409 91.74H27.359C20.3043 91.74 13.5385 88.9375 8.54999 83.9491C3.56152 78.9606 0.759033 72.1948 0.759033 65.14V65.14C0.758367 58.7829 3.0337 52.6355 7.17316 47.8108C11.3126 42.986 17.0426 39.8027 23.326 38.837V38.837Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.478 26.013C46.1684 22.0875 49.7753 18.877 53.9861 16.6597C58.197 14.4424 62.885 13.2851 67.644 13.288",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.329 38.533C23.3266 36.6986 23.6857 34.8817 24.3857 33.1861C25.0857 31.4905 26.1129 29.9494 27.4086 28.6508C28.7044 27.3523 30.2432 26.3218 31.9373 25.6182C33.6314 24.9145 35.4476 24.5516 37.282 24.55",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.4 91.74H27.35C20.2953 91.74 13.5295 88.9375 8.54099 83.9491C3.55252 78.9606 0.75 72.1948 0.75 65.14",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.1161 202.443H41.8411V230.718H70.1161V202.443Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.09 228.589L55.978 250.478L77.867 228.589H34.09Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.1161 127.454H41.8411V155.729H70.1161V127.454Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.09 153.601L55.978 175.49L77.867 153.601H34.09Z",
  fill: "#AC7FE0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "db"
}, /*#__PURE__*/React.createElement("rect", {
  width: 390.094,
  height: 441.208,
  fill: "white"
})));

var SvgDownloadBoy = function SvgDownloadBoy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 442,
    viewBox: "0 0 391 442",
    fill: "none",
    className: "hidden md:block absolute right-0 top-0 mt-8 mr-35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadBoy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DownloadBoy.644513c3.svg";
export { ForwardRef as ReactComponent };